module.exports = __webpack_public_path__ + "img/failed.437c5ba3.png";